export const getFlagCode = (selectedCountry) => {
  if (selectedCountry === "USA") {
    return "US";
  } else if (selectedCountry === "India") {
    return "IN";
  } else if (selectedCountry === "Canada") {
    return "CA";
  }
  return "";
};
